// if (!customElements.get('product-form')) {
//   customElements.define('product-form', class ProductForm extends HTMLElement {
//     constructor() {
//       super();

//       this.form = this.querySelector('form');
//       this.form.querySelector('[name=id]').disabled = false;
//       this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
//       this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
//       this.submitButton = this.querySelector('[type="submit"]');
//       if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
//     }

//     onSubmitHandler(evt) {
//       evt.preventDefault();
//       if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

//       this.handleErrorMessage();

//       this.submitButton.setAttribute('aria-disabled', true);
//       this.submitButton.classList.add('loading');
//       this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

//       const config = fetchConfig('javascript');
//       config.headers['X-Requested-With'] = 'XMLHttpRequest';
//       delete config.headers['Content-Type'];

//         const formData = new FormData(this.form);
//         if (this.cart) {
//           formData.append(
//             'sections',
//             this.cart.getSectionsToRender().map((section) => section.id)
//           );
//           formData.append('sections_url', window.location.pathname);
//           this.cart.setActiveElement(document.activeElement);
//         }
//         config.body = formData;

//         fetch(`${routes.cart_add_url}`, config)
//           .then((response) => response.json())
//           .then((response) => {
//             if (response.status) {
//               publish(PUB_SUB_EVENTS.cartError, {
//                 source: 'product-form',
//                 productVariantId: formData.get('id'),
//                 errors: response.errors || response.description,
//                 message: response.message,
//               });
//               this.handleErrorMessage(response.description);

//               const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
//               if (!soldOutMessage) return;
//               this.submitButton.setAttribute('aria-disabled', true);
//               this.submitButton.querySelector('span').classList.add('hidden');
//               soldOutMessage.classList.remove('hidden');
//               this.error = true;
//               return;
//             } else if (!this.cart) {
//               window.location = window.routes.cart_url;
//               return;
//             }

//           if (!this.error)
//               publish(PUB_SUB_EVENTS.cartUpdate, {
//                 source: 'product-form',
//                 productVariantId: formData.get('id'),
//                 cartData: response,
//           });
//           this.error = false;
//           const quickAddModal = this.closest('quick-add-modal');
//           if (quickAddModal) {
//             document.body.addEventListener('modalClosed', () => {
//               setTimeout(() => { this.cart.renderContents(response) });
//             }, { once: true });
//             quickAddModal.hide(true);
//           } else {
//             this.cart.renderContents(response);
//           }
//         })
//         .catch((e) => {
//           console.error(e);
//         })
//         .finally(() => {
//           this.submitButton.classList.remove('loading');
//           if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
//           if (!this.error) this.submitButton.removeAttribute('aria-disabled');
//           this.querySelector('.loading-overlay__spinner').classList.add('hidden');
//         });
//     }

//       handleErrorMessage(errorMessage = false) {
//         if (this.hideErrors) return;

//         this.errorMessageWrapper =
//           this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
//         if (!this.errorMessageWrapper) return;
//         this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

//         this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

//         if (errorMessage) {
//           this.errorMessage.textContent = errorMessage;
//         }
//       }
//   });
// }


// document.addEventListener('DOMContentLoaded', function () {
//   const productFormEl = document.querySelector('product-form');
//   const stickyAtcButton = document.querySelector('.cart-bar-sticky .add-to-cart-sticky');
//   if (productFormEl && stickyAtcButton) {
//     stickyAtcButton.addEventListener('click', function (e) {
//       e.preventDefault();
//       const spinner = stickyAtcButton.querySelector('.loading-overlay__spinner');
//       const buttonText = stickyAtcButton.querySelector('span');
//       stickyAtcButton.setAttribute('aria-disabled', true);
//       stickyAtcButton.classList.add('loading');
//       spinner.classList.remove('hidden');
//       buttonText.classList.add('hidden');
//       const promise = new Promise((resolve) => {
//         if (typeof productFormEl.onSubmitHandler === 'function') {
//           productFormEl.onSubmitHandler.call(productFormEl, e);
//           resolve();
//         } else {
//           const form = productFormEl.querySelector('form');
//           form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
//           resolve();
//         }
//       });
//       promise.finally(() => {
//         setTimeout(() => {
//           stickyAtcButton.classList.remove('loading');
//           stickyAtcButton.removeAttribute('aria-disabled');
//           spinner.classList.add('hidden');
//           buttonText.classList.remove('hidden');
//         }, 1000);
//       });
//     });
//   }
// });


if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.RESTRICTED_PRODUCT_ID = 14892798017904;
      this.RESTRICTION_TAG = 'Entry/Discovery Customer';
      this.isFirstTasteRestricted = 
      (window.__currentProductId__ === this.RESTRICTED_PRODUCT_ID) &&
      Array.isArray(window.__customerTags__) &&
      window.__customerTags__.includes(this.RESTRICTION_TAG);

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    processCartAfterAdd(response, formData) {
      return fetch(`${window.routes.cart_url}.js`, {
        headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' }
      })
      .then(res => res.ok ? res.json() : Promise.reject(new Error(`Cart fetch failed: ${res.status}`)))
      .then(fullCart => {
        console.log('Full cart before processing:', fullCart);

        // Group by variant_id
        const groups = fullCart.items.reduce((acc, item) => {
          const vid = item.variant_id;
          acc[vid] = acc[vid] || [];
          acc[vid].push(item);
          return acc;
        }, {});

        // Prepare updates for duplicates
        const updates = [];
        Object.values(groups).forEach(group => {
          if (group.length > 1) {
            const { mainItem, blankItems, blankTotalQty } = group.reduce(
              (acc, item) => {
                const uniqId = item.properties?.['Uniq-ID'] || '';
                if (uniqId.trim()) {
                  acc.mainItem = acc.mainItem || item; // Take first non-blank
                } else {
                  acc.blankItems.push(item);
                  acc.blankTotalQty += item.quantity;
                }
                return acc;
              },
              { mainItem: null, blankItems: [], blankTotalQty: 0 }
            );

            if (mainItem && blankTotalQty > 0) {
              const newQty = mainItem.quantity + blankTotalQty;
              const updateForm = new FormData();
              updateForm.append('id', mainItem.key);
              updateForm.append('quantity', newQty);
              updates.push(
                fetch(`${window.routes.cart_change_url}`, {
                  method: 'POST',
                  headers: { 'X-Requested-With': 'XMLHttpRequest' },
                  body: updateForm
                }).then(res => res.ok ? res.json() : Promise.reject(new Error(`Update failed: ${res.status}`)))
                  .then(res => console.log(`Updated ${mainItem.key} to ${newQty}:`, res))
                  .catch(err => console.error(`Update error for ${mainItem.key}:`, err))
              );

              blankItems.forEach(blankItem => {
                const removeForm = new FormData();
                removeForm.append('id', blankItem.key);
                removeForm.append('quantity', 0);
                updates.push(
                  fetch(`${window.routes.cart_change_url}`, {
                    method: 'POST',
                    headers: { 'X-Requested-With': 'XMLHttpRequest' },
                    body: removeForm
                  }).then(res => res.ok ? res.json() : Promise.reject(new Error(`Remove failed: ${res.status}`)))
                    .then(res => console.log(`Removed ${blankItem.key}:`, res))
                    .catch(err => console.error(`Remove error for ${blankItem.key}:`, err))
                );
              });
            } else if (!mainItem) {
              console.warn(`No main item for variant ${group[0].variant_id}`);
            }
          }
        });

        // Log duplicates
        const variantIds = fullCart.items.map(item => item.variant_id);
        const duplicates = [...new Set(variantIds.filter((id, i) => variantIds.indexOf(id) !== i))];
        if (duplicates.length) {
          console.log('Duplicates found:', duplicates, '- Merging...');
        } else {
          console.log('No duplicates.');
        }

        // Execute updates and re-render
        return Promise.all(updates).then(() => {
          if (updates.length) console.log('Merges complete.');
          return new Promise((resolve) => {
            setTimeout(() => {
              fetch(`${window.routes.cart_url}.js`, {
                headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' }
              })
              .then(res => res.ok ? res.json() : Promise.reject(new Error(`Re-fetch failed: ${res.status}`)))
              .then(updatedCart => {
                // Render with sections if available
                const sectionsToRender = this.cart?.getSectionsToRender().map(s => s.id) || [];
                if (sectionsToRender.length && this.cart) {
                  const sectionsUrl = `${window.location.pathname}?sections=${sectionsToRender.join(',')}`;
                  fetch(sectionsUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
                    .then(res => res.ok ? res.json() : Promise.reject(new Error(`Sections failed: ${res.status}`)))
                    .then(sections => {
                      this.cart.renderContents({ ...updatedCart, sections });
                      resolve(updatedCart);
                    })
                    .catch(err => {
                      console.error('Sections error:', err);
                      this.cart.renderContents(updatedCart);
                      resolve(updatedCart);
                    });
                } else if (this.cart) {
                  this.cart.renderContents(updatedCart);
                  resolve(updatedCart);
                } else {
                  resolve(updatedCart);
                }

                // Publish and update counts
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  cartData: updatedCart
                });
                document.querySelectorAll('.cart-count-bubble, [data-cart-count]').forEach(el => {
                  el.textContent = updatedCart.item_count;
                });
              })
              .catch(err => {
                console.error('Re-fetch error:', err);
                resolve(null);
              });
            }, 200);
          });
        }).catch(err => {
          console.error('Update error:', err);
          throw err;
        });
      })
      .catch(err => console.error('Initial fetch error:', err));
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      // New js for disable ATC Start
      if (this.isFirstTasteRestricted) {
      this.handleErrorMessage(
        'The First Taste Bundle is a one-time purchase only.'
      );
        return Promise.reject('First Taste Bundle: one-time purchase restriction');
      }
       // New js for disable ATC End
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return Promise.reject();

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      
      if (this.cart) {
        formData.append(
          'sections',
          this.cart.getSectionsToRender().map((section) => section.id)
        );
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      
      let scriptElement = document.getElementById('addon-variants-json');
      let addonVariants = scriptElement ? JSON.parse(scriptElement.textContent) : [];
      let randomSixDigit = Math.floor(100000 + Math.random() * 900000);
      let uniqInput = document.getElementById('uniq-bundle-id');
        if (uniqInput) {
          uniqInput.value = randomSixDigit;
        } else {
          console.warn('Element with id "uniq-bundle-id" not found. Skipping value set.');
        }

      addonVariants.forEach((variantID, index) => {
        formData.append(`items[${index}][id]`, variantID);
        formData.append(`items[${index}][quantity]`, 1);
        formData.append(`items[${index}][properties][Uniq-ID]`, randomSixDigit);
        formData.append(`items[${index}][properties][_Child_product]`, randomSixDigit);
        formData.append(`properties[Uniq-ID]`, randomSixDigit);
      });

      config.body = formData;

      return fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.errors || response.description,
              message: response.message,
            });
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return Promise.reject();
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return Promise.reject();
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return Promise.reject();
          }

          if (!this.error) {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              cartData: response,
            });

            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              quickAddModal.hide(true);
              document.body.addEventListener('modalClosed', () => {
                return this.processCartAfterAdd(response, formData);
              }, { once: true });
            } else {
              return this.processCartAfterAdd(response, formData);
            }

            const mainQuantityInput = this.form.querySelector('input[name="quantity"]');
            if (mainQuantityInput) {
              mainQuantityInput.value = 1;
              mainQuantityInput.dispatchEvent(new Event('change', { bubbles: true }));
            }

            const lowerBarQuantityEl = document.querySelector('.lower-bar-atc quantity-input.quantity');
            if (lowerBarQuantityEl) {
              const lowerBarInput = lowerBarQuantityEl.querySelector('input');
              if (lowerBarInput) {
                lowerBarInput.value = 1;
                lowerBarInput.dispatchEvent(new Event('change', { bubbles: true }));
              }
            }
          }
          this.error = false;
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
  });
}


document.addEventListener('DOMContentLoaded', function () {
  const productFormEl = document.querySelector('product-form');
  const stickyAtcButton = document.querySelector('.cart-bar-sticky .add-to-cart-sticky');
  if (productFormEl && stickyAtcButton) {
    stickyAtcButton.addEventListener('click', function (e) {
      e.preventDefault();
      const spinner = stickyAtcButton.querySelector('.loading-overlay__spinner');
      const buttonText = stickyAtcButton.querySelector('span');
      stickyAtcButton.setAttribute('aria-disabled', true);
      stickyAtcButton.classList.add('loading');
      spinner.classList.remove('hidden');
      buttonText.classList.add('hidden');
      const promise = new Promise((resolve) => {
        if (typeof productFormEl.onSubmitHandler === 'function') {
          const submitPromise = productFormEl.onSubmitHandler.call(productFormEl, e);
          submitPromise.then(() => {
            spinner.classList.add('hidden');
            buttonText.classList.remove('hidden');
            stickyAtcButton.classList.remove('loading');
            stickyAtcButton.removeAttribute('aria-disabled');
            resolve();
          }).catch(() => {
            spinner.classList.add('hidden');
            buttonText.classList.remove('hidden');
            stickyAtcButton.classList.remove('loading');
            stickyAtcButton.removeAttribute('aria-disabled');
            resolve();
          });
        } else {
          const form = productFormEl.querySelector('form');
          form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
          setTimeout(() => {
            spinner.classList.add('hidden');
            buttonText.classList.remove('hidden');
            stickyAtcButton.classList.remove('loading');
            stickyAtcButton.removeAttribute('aria-disabled');
            resolve();
          }, 1000);
        }
      });
    });
  }
});